import React from 'react';
import ReactDOM from 'react-dom/client';
import { Auth0Provider } from '@auth0/auth0-react';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const domain = process.env.REACT_APP_AUTH0_DOMAIN || 'id-development.agridence.com';
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID || '8DIvzGWiGscvVNqYesJjTLE4npX3VIll';
const audience = process.env.REACT_APP_AUTH0_AUDIENCE || 'com.agridence.ai.v1';

const onRedirectCallback = (appState?: any) => {
  // After login, redirect to the intended page or home
  window.history.replaceState(
    {},
    document.title,
    appState?.returnTo || window.location.pathname
  );
};

root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      onRedirectCallback={onRedirectCallback}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: audience,
        scope: "openid profile email"
      }}
      cacheLocation="localstorage"
      useRefreshTokens={true}
    >
      <App />
    </Auth0Provider>
  </React.StrictMode>
);